import { siteNames } from '@seek/melways-sites';
// Emails
// ==========================================================
export const CUSTOMER_SERVICE_SENDER_EMAIL_ADDRESS = {
    [siteNames.employer.seek.au]: 'customerservice@seek.com.au',
    [siteNames.employer.seek.nz]: 'customerservice@seek.co.nz',
    [siteNames.employer.seek.hk]: 'customerservice-hk@seek.com',
    [siteNames.employer.seek.th]: 'customerservice-th@seek.com',
    [siteNames.employer.seek.sg]: 'customerservice-sg@seek.com',
    [siteNames.employer.seek.id]: 'customerservice-id@seek.com',
    [siteNames.employer.seek.ph]: 'customerservice-ph@seek.com',
    [siteNames.employer.seek.my]: 'customerservice-my@seek.com',
    [siteNames.candidate.seek.au]: 'customerservice-candidate@seek.com.au',
    [siteNames.candidate.seek.nz]: 'customerservice-candidate@seek.co.nz',
    [siteNames.candidate.jobsdb.hk]: 'hk-customer-service-candidate-sender@seek.com',
    [siteNames.candidate.jobsdb.th]: 'th-customer-service-candidate-sender@seek.com',
    [siteNames.candidate.jobstreet.sg]: 'sg-customer-service-candidate-sender@seek.com',
    [siteNames.candidate.jobstreet.id]: 'id-customer-service-candidate-sender@seek.com',
    [siteNames.candidate.jobstreet.ph]: 'ph-customer-service-candidate-sender@seek.com',
    [siteNames.candidate.jobstreet.my]: 'my-customer-service-candidate-sender@seek.com',
};
export const CUSTOMER_SERVICE_REPLY_TO_EMAIL_ADDRESS = {
    [siteNames.employer.seek.au]: 'noreply@seek.com.au',
    [siteNames.employer.seek.nz]: 'noreply@seek.co.nz',
    [siteNames.employer.seek.hk]: 'hk-customer-service-reply@seek.com',
    [siteNames.employer.seek.th]: 'th-customer-service-reply@seek.com',
    [siteNames.employer.seek.sg]: 'sg-customer-service-reply@seek.com',
    [siteNames.employer.seek.id]: 'id-customer-service-reply@seek.com',
    [siteNames.employer.seek.ph]: 'ph-customer-service-reply@seek.com',
    [siteNames.employer.seek.my]: 'my-customer-service-reply@seek.com',
    [siteNames.candidate.seek.au]: 'candidate-noreply@seek.com.au',
    [siteNames.candidate.seek.nz]: 'candidate-noreply@seek.co.nz',
    [siteNames.candidate.jobsdb.hk]: 'hk-customer-service-candidate-reply@seek.com',
    [siteNames.candidate.jobsdb.th]: 'th-customer-service-candidate-reply@seek.com',
    [siteNames.candidate.jobstreet.sg]: 'sg-customer-service-candidate-reply@seek.com',
    [siteNames.candidate.jobstreet.id]: 'id-customer-service-candidate-reply@seek.com',
    [siteNames.candidate.jobstreet.ph]: 'ph-customer-service-candidate-reply@seek.com',
    [siteNames.candidate.jobstreet.my]: 'my-customer-service-candidate-reply@seek.com',
};
export const CANDIDATE_MAIL_SENDER_EMAIL_ADDRESS = {
    [siteNames.employer.seek.au]: 'noreply@jobapplications.seek.com.au',
    [siteNames.employer.seek.nz]: 'noreply@jobapplications.seek.co.nz',
    [siteNames.employer.seek.hk]: 'hk-candidate-mail-sender@seek.com',
    [siteNames.employer.seek.th]: 'th-candidate-mail-sender@seek.com',
    [siteNames.employer.seek.sg]: 'sg-candidate-mail-sender@seek.com',
    [siteNames.employer.seek.id]: 'id-candidate-mail-sender@seek.com',
    [siteNames.employer.seek.ph]: 'ph-candidate-mail-sender@seek.com',
    [siteNames.employer.seek.my]: 'my-candidate-mail-sender@seek.com',
    [siteNames.candidate.seek.au]: 'noreply@jobapplications.seek.com.au',
    [siteNames.candidate.seek.nz]: 'noreply@jobapplications.seek.co.nz',
    [siteNames.candidate.jobsdb.hk]: 'hk-candidate-mail-sender@seek.com',
    [siteNames.candidate.jobsdb.th]: 'th-candidate-mail-sender@seek.com',
    [siteNames.candidate.jobstreet.sg]: 'sg-candidate-mail-sender@seek.com',
    [siteNames.candidate.jobstreet.id]: 'id-candidate-mail-sender@seek.com',
    [siteNames.candidate.jobstreet.ph]: 'ph-candidate-mail-sender@seek.com',
    [siteNames.candidate.jobstreet.my]: 'my-candidate-mail-sender@seek.com',
};
export const CANDIDATE_MAIL_REPLY_TO_EMAIL_ADDRESS = {
    [siteNames.employer.seek.au]: 'noreply@jobapplications.seek.com.au',
    [siteNames.employer.seek.nz]: 'noreply@jobapplications.seek.co.nz',
    [siteNames.employer.seek.hk]: 'hk-candidate-mail-reply@seek.com',
    [siteNames.employer.seek.th]: 'th-candidate-mail-reply@seek.com',
    [siteNames.employer.seek.sg]: 'sg-candidate-mail-reply@seek.com',
    [siteNames.employer.seek.id]: 'id-candidate-mail-reply@seek.com',
    [siteNames.employer.seek.ph]: 'ph-candidate-mail-reply@seek.com',
    [siteNames.employer.seek.my]: 'my-candidate-mail-reply@seek.com',
    [siteNames.candidate.seek.au]: 'noreply@jobapplications.seek.com.au',
    [siteNames.candidate.seek.nz]: 'noreply@jobapplications.seek.co.nz',
    [siteNames.candidate.jobsdb.hk]: 'hk-candidate-mail-reply@seek.com',
    [siteNames.candidate.jobsdb.th]: 'th-candidate-mail-reply@seek.com',
    [siteNames.candidate.jobstreet.sg]: 'sg-candidate-mail-reply@seek.com',
    [siteNames.candidate.jobstreet.id]: 'id-candidate-mail-reply@seek.com',
    [siteNames.candidate.jobstreet.ph]: 'ph-candidate-mail-reply@seek.com',
    [siteNames.candidate.jobstreet.my]: 'my-candidate-mail-reply@seek.com',
};
// Customer Experience Email
// Note: All the APAC markets have the same email ID for now.
// Update this constant when email IDs are available.
const cse_email = 'customerexperience@seek.com.au';
export const CUSTOMER_EXPERIENCE_SENDER_EMAIL_ADDRESS = {
    [siteNames.employer.seek.au]: cse_email,
    [siteNames.employer.seek.nz]: cse_email,
    [siteNames.employer.seek.hk]: cse_email,
    [siteNames.employer.seek.th]: cse_email,
    [siteNames.employer.seek.sg]: cse_email,
    [siteNames.employer.seek.id]: cse_email,
    [siteNames.employer.seek.ph]: cse_email,
    [siteNames.employer.seek.my]: cse_email,
};
const CUSTOMER_SERVICE_NAME = 'SEEK Customer Service';
// Email Sender Names
// ==========================================================
export const CUSTOMER_SERVICE_SENDER_EMAIL_NAME = {
    [siteNames.employer.seek.au]: CUSTOMER_SERVICE_NAME,
    [siteNames.employer.seek.nz]: CUSTOMER_SERVICE_NAME,
    [siteNames.employer.seek.hk]: CUSTOMER_SERVICE_NAME,
    [siteNames.employer.seek.th]: CUSTOMER_SERVICE_NAME,
    [siteNames.employer.seek.sg]: CUSTOMER_SERVICE_NAME,
    [siteNames.employer.seek.id]: CUSTOMER_SERVICE_NAME,
    [siteNames.employer.seek.ph]: CUSTOMER_SERVICE_NAME,
    [siteNames.employer.seek.my]: CUSTOMER_SERVICE_NAME,
    [siteNames.candidate.seek.au]: CUSTOMER_SERVICE_NAME,
    [siteNames.candidate.seek.nz]: CUSTOMER_SERVICE_NAME,
    [siteNames.candidate.jobsdb.hk]: CUSTOMER_SERVICE_NAME,
    [siteNames.candidate.jobsdb.th]: CUSTOMER_SERVICE_NAME,
    [siteNames.candidate.jobstreet.sg]: CUSTOMER_SERVICE_NAME,
    [siteNames.candidate.jobstreet.id]: CUSTOMER_SERVICE_NAME,
    [siteNames.candidate.jobstreet.ph]: CUSTOMER_SERVICE_NAME,
    [siteNames.candidate.jobstreet.my]: CUSTOMER_SERVICE_NAME,
};
const REPLY_EMAIL_NAME = 'SEEK';
export const CUSTOMER_SERVICE_REPLY_TO_EMAIL_NAME = {
    [siteNames.employer.seek.au]: REPLY_EMAIL_NAME,
    [siteNames.employer.seek.nz]: REPLY_EMAIL_NAME,
    [siteNames.employer.seek.hk]: REPLY_EMAIL_NAME,
    [siteNames.employer.seek.th]: REPLY_EMAIL_NAME,
    [siteNames.employer.seek.sg]: REPLY_EMAIL_NAME,
    [siteNames.employer.seek.id]: REPLY_EMAIL_NAME,
    [siteNames.employer.seek.ph]: REPLY_EMAIL_NAME,
    [siteNames.employer.seek.my]: REPLY_EMAIL_NAME,
    [siteNames.candidate.seek.au]: REPLY_EMAIL_NAME,
    [siteNames.candidate.seek.nz]: REPLY_EMAIL_NAME,
    [siteNames.candidate.jobsdb.hk]: REPLY_EMAIL_NAME,
    [siteNames.candidate.jobsdb.th]: REPLY_EMAIL_NAME,
    [siteNames.candidate.jobstreet.sg]: REPLY_EMAIL_NAME,
    [siteNames.candidate.jobstreet.id]: REPLY_EMAIL_NAME,
    [siteNames.candidate.jobstreet.ph]: REPLY_EMAIL_NAME,
    [siteNames.candidate.jobstreet.my]: REPLY_EMAIL_NAME,
};
// Phone Numbers
// ==========================================================
export const CUSTOMER_SERVICE_PHONE_NUMBER = {
    [siteNames.employer.seek.au]: '1300 658 700',
    [siteNames.employer.seek.nz]: '0508 733 569',
    [siteNames.candidate.seek.au]: '1300 658 700',
    [siteNames.candidate.seek.nz]: '0508 733 569',
};
export const SALES_PHONE_NUMBER = {
    [siteNames.employer.seek.au]: '13 64 34',
    [siteNames.employer.seek.nz]: '0800 505 080',
    [siteNames.candidate.seek.au]: '13 64 34',
    [siteNames.candidate.seek.nz]: '0800 505 080',
};
export const FINANCE_PHONE_NUMBER = {
    [siteNames.employer.seek.au]: '1300 888 079',
    [siteNames.employer.seek.nz]: '0508 733 571',
    [siteNames.candidate.seek.au]: '1300 888 079',
    [siteNames.candidate.seek.nz]: '0508 733 571',
};
// CS Office Hours
// ================
export const CUSTOMER_SERVICE_HOURS = {
    [siteNames.employer.seek.au]: 'Monday to Friday, 8:30am - 6pm AEST',
    [siteNames.employer.seek.nz]: 'Monday to Friday, 9am - 5pm NZST',
    [siteNames.employer.seek.hk]: 'Monday to Friday, 9am - 6pm HKT',
    [siteNames.employer.seek.th]: 'Monday to Friday, 8:30am - 5:30pm ICT',
    [siteNames.employer.seek.sg]: 'Monday to Friday, 8:30am - 5:30pm SGT',
    [siteNames.employer.seek.id]: 'Monday to Friday, 08.00 - 17.00 WIB',
    [siteNames.employer.seek.ph]: 'Monday to Friday, 8am - 5pm PHT',
    [siteNames.employer.seek.my]: 'Monday to Friday, 8:30am - 5:30pm MYT',
    [siteNames.candidate.seek.au]: 'Monday to Friday, 8:30am - 6pm AEST',
    [siteNames.candidate.seek.nz]: 'Monday to Friday, 9am - 5pm NZST',
    [siteNames.candidate.jobsdb.hk]: 'Monday to Friday, 9am - 6pm HKT',
    [siteNames.candidate.jobsdb.th]: 'Monday to Friday, 8:30am - 5:30pm ICT',
    [siteNames.candidate.jobstreet.sg]: 'Monday to Friday, 8:30am - 5:30pm SGT',
    [siteNames.candidate.jobstreet.id]: 'Monday to Friday, 08.00 - 17.00 WIB',
    [siteNames.candidate.jobstreet.ph]: 'Monday to Friday, 8am - 5pm PHT',
    [siteNames.candidate.jobstreet.my]: 'Monday to Friday, 8:30am - 5:30pm MYT',
};
//# sourceMappingURL=contact-info.js.map